// Feature Configurations
import complianceHub from 'Features/ComplianceHub/complianceHubConfiguration';

import administration from '../../Features/Administration/administrationConfiguration';
import communications from '../../Features/Communications/communicationsConfiguration';
import documents from '../../Features/Documents/documentsConfiguration';
import inspections from '../../Features/Inspections/inspectionsConfiguration';
import insurance from '../../Features/Insurance/insuranceConfiguration';
import leasing from '../../Features/Leasing/leasingConfiguration';
import locations from '../../Features/Locations/locationsConfiguration';
import payments from '../../Features/Payments/paymentsConfiguration';
import paymentsMarketing from '../../Features/Payments/paymentsMarketingConfiguration';
import reports from '../../Features/Reports/reportsConfiguration';
import requests from '../../Features/Requests/requestsConfiguration';
import sales from '../../Features/Sales/salesConfiguration';

// Order determines navigation order
const ownerOperatorFeatures = [
    requests,
    documents,
    sales,
    communications,
    complianceHub,
    leasing,
    ...(AUTH_TARGET === 'prod' ? [] : [inspections]),
    locations,
    insurance,
    payments,
    paymentsMarketing,
    reports,
    administration,
];

export default ownerOperatorFeatures;
